import type { FaireProductEntity } from "../../entity_types/product";

export const bath_3: FaireProductEntity = {
  token: "bath-3",
  type: "product",
  name: "Rose Petal Bath Bombs",
  brandName: "Pure Soap Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/8a01346a1e6c6704aad0ba0cffc6c7cb04388f5fb882fad736a5379218d21f1e.webp",
  priceDollars: 10,
  msrpDollars: 16,
  freeShipping: true,
  isBestseller: true,
  description: "",
  categoryTokens: ["cat_beauty-all"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
